import { Button, OptionSheet } from '@relay-towing/ui';
import { Plus } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { useDriverChecklists } from '../../hooks/useTruckInspections';

/**
 * Inspections' New, for a member who runs them (`inspections.create`): the
 * checklists in a sheet, and the one picked starts a run
 * (InspectionRunScreen). A driver only ever needs to choose which one they
 * are doing, so they are not shown a list of checklists to look through.
 */
export function StartInspectionButton() {
  const navigate = useNavigate();
  const checklists = useDriverChecklists();
  return (
    <OptionSheet
      title="Which checklist?"
      options={(checklists.data ?? []).map((row) => ({
        value: row.id,
        label: row.name,
      }))}
      emptyMessage={
        checklists.isPending ? 'Loading the checklists' : 'No checklists yet'
      }
      onValueChange={(id) => navigate(`/inspections/run/${id}`)}
      trigger={
        <Button variant="soft" size="lg" pill leadingIcon={<Plus />}>
          New
        </Button>
      }
    />
  );
}
